import { buildFamsPageMessages } from 'config/fams-menu';

export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒後重新取得',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  ...buildFamsPageMessages('zh-TW'),
};
